import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { api } from '.';
type GetParamsType = {
	page?: number;
	search_category?: string;
	search?: string;
	type?: string;
	row?: number;
};
export type Notice = {
	admin_name: string;
	notice_enrollment_date: string;
	fixed_yn: string;
	notice_hit: number;
	notice_pk: number;
	notice_title: string;
	notice_image_url: string;
};
export type Newsletter = {
	admin_name: string;
	newsletter_enrollment_date: string;
	fixed_yn: string;
	newsletter_hit: number;
	newsletter_pk: number;
	newsletter_title: string;
	newsletter_image_url: string;
};
export type Gallery = {
	admin_name: string;
	gallery_enrollment_date: string;
	fixed_yn: string;
	gallery_hit: number;
	gallery_pk: number;
	gallery_title: string;
	gallery_image_url: string;
};

export type Trend = {
	admin_name: string;
	trend_enrollment_date: string;
	fixed_yn: string;
	trend_hit: number;
	trend_pk: number;
	trend_title: string;
	trend_image_url: string;
};
type GetInfoResType = {
	gallery?: Gallery[];
	notice?: Notice[];
	newsletter?: Newsletter[];
	trend?: Trend[];
	trend_count: number;
	notice_count: number;
	newsletter_count: number;
	gallery_count: number;
};
export const useGetInfoApi = (params: GetParamsType) => {
	const url = '/v1/front/getInfo';
	return useQuery<AxiosResponse, AxiosError, GetInfoResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
	});
};
type GetInfoDetailParamsType = {
	info_pk: number | string;
	type: string;
};
export type GalleryDetail = {
	admin_pk: number;
	file_pk: number;
	admin_name: string;
	gallery_content: string;
	gallery_enrollment_date: string;
	gallery_exposure_yn: string;
	gallery_hit: number;
	gallery_image_type: string;
	gallery_image_url: string;
	gallery_pk: number;
	gallery_title: string;
	gallery_update_date: string;
	gallery_video_url: string;
};

export type NoticeDetail = {
	admin_pk: number;
	admin_name: string;
	notice_content: string;
	notice_enrollment_date: string;
	notice_exposure_seq: string;
	notice_exposure_yn: string;
	notice_hit: number;
	notice_pk: number;
	notice_title: string;
	notice_update_date: string;
};
export type NewsletterDetail = {
	admin_pk: number;
	admin_name: string;
	newsletter_content: string;
	newsletter_enrollment_date: string;
	newsletter_exposure_yn: string;
	newsletter_hit: number;
	newsletter_pk: number;
	newsletter_title: string;
	newsletter_update_date: string;
};
export type TrendDetail = {
	admin_pk: number;
	admin_name: string;
	trend_content: string;
	trend_enrollment_date: string;
	trend_exposure_yn: string;
	trend_hit: number;
	trend_pk: number;
	trend_title: string;
	trend_update_date: string;
	trend_video_url: string;
};
export type FileDetal = {
	file_original_name: string;
	file_path: string;
	file_size: number;
	file_pk: string;
};
export type InfoDetailResType = {
	gallery?: GalleryDetail;
	notice?: NoticeDetail;
	newsletter?: NewsletterDetail;
	trend?: TrendDetail;
	notice_file: FileDetal[];
	newsletter_file: FileDetal[];
	gallery_file: FileDetal[];
	trend_file: FileDetal[];
	next_pk: number;
	prev_pk: number;
};

export const useGetInfoDetailApi = (params: GetInfoDetailParamsType) => {
	const url = '/v1/front/getInfoDetail';
	return useQuery<AxiosResponse, AxiosError, InfoDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
	});
};

// ========================= 팝업 START  ===============================
export type Popup = {
	popup_pk: number | string;
	popup_name: string;
	popup_image: string;
	popup_url: string;
	popup_exposure_yn: string;
	popup_exposure_start_date: string;
	popup_exposure_end_date: string;
	popup_enrollment_date: string;
	file_pk: string | number;
};

type GetPopupResType = {
	popup: Popup[];
	popup_count: string;
};

export const useGetPopupApi = () => {
	const url = '/v1/front/getPopup';
	return useQuery<AxiosResponse, AxiosError, GetPopupResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};
